import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="app-footer">
      <img src={process.env.PUBLIC_URL + '/line-manutan.png'} alt="line manutan" className="app-footer-left" />
      <div className="app-footer-inner">
        <p>
          Site interne — réservé au personnel de Manutan SAS. SIRET : 334 668 852 00042. Capital social : 16 072 720 €. Tous droits réservés.
        </p>
      </div>
      <img src={process.env.PUBLIC_URL + '/character-manutan.png'} alt="character manutan" className="app-footer-right" />
    </footer>
  );
};

export default Footer;
